import { useState, useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import Modal from "react-modal";
import { ExcelRenderer } from "react-excel-renderer";
import axios from "axios";
import moment from "moment";

import fileDownload from "js-file-download";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { getCompanyDashboardData, getCompanyExportToExcel, uploadBulkCompanyDetails, companySampleFileExportToExcel } from "../../../Helpers/APIEndPoints/EndPoints";
import "./CompanyMaster.css";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";

Modal.setAppElement("#root"); // Use the selector for your root element

const CompanyMaster = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const context = getContext();
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [dashboardData, setDashboardData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);

  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenError, setModalIsOpenError] = useState(false);

  const [bulkUploadRequestExcelFileName, setBulkUploadRequestExcelFileName] = useState("No File Uploaded");
  const [selectedFile, setSelectedFile] = useState(null);

  const exportToExcelFunction = async () => {
    const params = {
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: getCompanyExportToExcel,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
     
        fileDownload(response.data, `Company_` + `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` + `.xlsx`);
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const openModalError = () => {
    setModalIsOpenError(true);
  };
  const closeModalError = () => {
    setModalIsOpenError(false);
    clearFunction();
  };

  const openModal = () => {
    setModalIsOpen(true);
    clearFunction();
  };

  const closeModal = () => {
    setModalIsOpen(false);
    clearFunction();
  };

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const getDashboardData = async (btn: any) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    };

    const resp = await APICall(getCompanyDashboardData, obj);

    if (resp?.Data?.Data.length > 0) {
      setDashboardData(resp?.Data?.Data);
    } else {
      setDashboardData([]);
    }
    setCount(resp?.Data?.Data?.[0]?.TotalCount || resp?.Data?.Data?.length || 0);
    hideLoader();
  };

  const onUploadValidationCheck = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!bulkUploadRequestExcelFileName || bulkUploadRequestExcelFileName === "" || bulkUploadRequestExcelFileName === "No File Uploaded") {
      formErrorObj["bulkUpload_isEmpty"] = "Please upload file.";
      setFormErrors(formErrorObj);
    }
  };

  const handleUpload = async () => {
    await onUploadValidationCheck();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });
    let fileInBase64 = "";
    if (isEmpty === true) {
     
      const formData = new FormData();
      // 'file' should match your backend's file input name
      formData.append("file", selectedFile);
      // @ts-ignore
      formData.append("ImportExcelUserId", context?.Id);

      const data = await APICall(uploadBulkCompanyDetails, formData, HttpMethod.POST, false, "", true);

      if (data.Message === "Ok") {
        // Close the modal after the upload is complete (or handle errors appropriately).
        closeModal();
        clearFunction();
        notify(0, data?.Data);
        getDashboardData(""); // Success message
      } else if (data.Message === "VALIDATION_ERROR" || data.Message === "error") {
        // notify(1, Message);
        openModalError();
        // @ts-ignore
        setErrorMessage(data);
      } else if (data.Message === "Fail") {
        notify(1, data.Data?.Data?.Message || data?.Data?.Data);
      } else {
        notify(1, JSON.stringify(data?.Message));
      }
    }
  };

  const bulkUploadRequestExcelFileChange = (param: any) => {
    let bulkUploadRequestExcelFile = param.target.files[0];
    if (param.target.files.length > 0) {
      if (bulkUploadRequestExcelFile.size && bulkUploadRequestExcelFile.size <= 31457280) {
        let fileExtLength = bulkUploadRequestExcelFile.name.split(".");
        if (fileExtLength.length === 2) {
          let fileExtensionName = bulkUploadRequestExcelFile.name.split(".")[1].toLowerCase();
          if (fileExtensionName === "xlsx") {
            formErrorObj = {};
            setFormErrors({});

            setBulkUploadRequestExcelFileName(bulkUploadRequestExcelFile.name);
            ExcelRenderer(bulkUploadRequestExcelFile, async (err, resp) => {
              if (err) {
                clearFunction();
                notify(1, err);
              } else {
                if (resp.rows[0][0] !== "Company" && resp.rows[0][1] !== "Code" && resp.rows[0][2] !== "IsActive") {
                  clearFunction();
                  notify(1, "Invalid excel file, Please refer sample excel format.");
                } else {
                  setSelectedFile(bulkUploadRequestExcelFile);
                  // await htmlEncodeAllFields(resp.rows);
                }
              }
            });
          } else {
            clearFunction();
            notify(1, "You should uplaod excel file only.");
          }
        } else {
          clearFunction();
          notify(1, "You should upload valid excel file only, file name contains multiple extensions.");
        }
      } else {
        clearFunction();
        notify(1, "File size should not be greater than 30 MB.");
      }
    } else {
      clearFunction();
      notify(1, "Invalid file selected");
    }
  };

  const clearFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setBulkUploadRequestExcelFileName("No File Uploaded");
    setSelectedFile(null);
  };

  const downloadSampleExcel = async () => {
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: companySampleFileExportToExcel,
        data: {},
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
       
        fileDownload(response.data, `Sample_Company.xlsx`);
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };
  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "Name",
      label: "Company",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "Code",
      label: "Code",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          const IsFromSFData = tableMeta.tableData[tableMeta.rowIndex].IsFromSFData;
          if (IsFromSFData) return null;
          return (
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", {
                      state: { id },
                    });
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end"> 
              <div className="col-xl-3 col-lg-4 col-md-4 SearchBoxCompany">
                <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                  <div className="col-lg-12 mt-1 p-0 searchInput">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 ml-2 com_mob p-0">
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <Tooltip title="import to excel">
                    <button className="btn btn-submit" onClick={openModal}>
                      <i className="fa fa-upload"></i>
                    </button>
                  </Tooltip>

                  <Tooltip title="export to excel" style={{ marginLeft: "5px", cursor: "pointer" }}>
                    <button
                      className="btn btn-submit"
                      onClick={() => {
                        if (dashboardData.length === 0) {
                          notify(1, "No data available");
                        } else {
                          exportToExcelFunction();
                        }
                      }}
                    >
                      <i className="fa fa-download"></i>
                    </button>
                  </Tooltip>

                  <ButtonComponent
                    className="btn btn-submit"
                    style={{
                      marginLeft: 5,
                      cursor: "pointer",
                    }}
                    icon={"fas fa-plus-circle"}
                    value={"Create"}
                    onClick={() => {
                      navigate("edit", {
                        state: {
                          id: 0,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
        <div className="col-lg-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-md-4"></div>
            <div className="col-lg-4 col-md-2"></div>
            <div className="col-lg-4 col-md-6">
              <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                <div className="col-lg-12 mt-1 p-0 searchInput">
                  <InputForm
                    value={searchText}
                    placeholder={"Search"}
                    isDisabled={false}
                    textArea={false}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                  <i className="fa fa-search ml-2" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div>
        <div className="clearfix"></div>
        <DynamicGrid options={Options} data={dashboardData} columns={GridColumns} />
      </div>

      <div className="ModalSize">
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="File Upload Modal"
          style={{
            content: {
              width: "30%", // Adjust this value as needed
              height: "16em", // Adjust this value as needed
              margin: "auto", // Center the modal horizontally
            },
          }}
        >
          <div className="alignment">
            <div className="col-lg-12 p-0">
              <div className="row" style={{ marginRight: "5px", float: "right" }}>
                {/* <a
                  href={require("../../../Assets/SampleFile/Company_Sample.xlsx")}
                  target="_blank"
                  className="btn btn-cancel"
                  download="Company_Sample.xlsx"
                >
                  <i className="fa fa-download"></i> Sample File
                </a> */}
                <a onClick={downloadSampleExcel} target="_blank" rel="noopener noreferrer" className="btn btn-cancel">
                  <i className="fa fa-download"></i> Sample File
                </a>
              </div>
            </div>
            <div className="col-lg-12 p-0">
              <div className="row">
                <div className="col-lg-12 col-md-12" style={{ marginBottom: "15px" }}>
                  <div className="form-group"></div>
                  <label>Import Excel</label>
                  <sup style={{ fontSize: "13px" }}>*</sup>
                  <input autoComplete={AutoCompleteValue} onChange={bulkUploadRequestExcelFileChange} accept=".xlsx" className="form-control" type="file" />
                  <p style={{ color: "red" }}>{formErrors["bulkUpload_isEmpty"]}</p>
                </div>
                <div className="col-lg-12 col-md-12">
                  <button className="btn btn-submit" onClick={handleUpload}>
                    Upload
                  </button>
                  <button className="btn btn-cancel" onClick={closeModal} style={{ marginLeft: "10px" }}>
                  <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="ModalSize">
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpenError}
          onRequestClose={closeModalError}
          contentLabel="Error Message"
          style={{
            content: {
              width: "30%", // Adjust this value as needed
              height: "16em", // Adjust this value as needed
              margin: "auto", // Center the modal horizontally
              backgroundColor: "antiquewhite",
            },
          }}
        >
          <div className="col-lg-12 p-0">
            <div className="row">
              <div className="col-lg-12 col-md-12" style={{ marginBottom: "15px" }}>
                {errorMessage?.["Data"]?.map((errorMag: any, index: any) => (
                  <p key={index} className="ErrorMessage">
                    {index + 1}. {errorMag}
                  </p>
                ))}
              </div>
              <div className="col-lg-12 col-md-12">
                <button className="btn btn-cancel" onClick={closeModalError} style={{ marginLeft: "10px", float: "right" }}>
                  <i className="far fa-times-circle"></i> Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default CompanyMaster;
